import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-host-sub-menu",
  "use": "app-icon-host-sub-menu-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-host-sub-menu\"><path d=\"M2 16V0h12v16zm1.5-1.5h9v-13h-9zM7 13v-2h2v2zM5 4.5V3h6v1.5zm0 3V6h6v1.5z\" data-name=\"icon host16-01\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol